// extracted by mini-css-extract-plugin
export default {"textarea":"create_textarea__Od8aV"};